import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import parseSides from 'parse-css-sides';
export function createBreakpointMap(prop) {
  return {
    mobile: Array.isArray(prop) ? prop[0] : prop,
    tablet: Array.isArray(prop) ? prop[1] : prop,
    desktop: Array.isArray(prop) ? prop[2] : prop
  };
}
export function getPaddingValueFromStyledSystemNumber(padding) {
  var theme = useContext(ThemeContext);

  if (!theme.space) {
    return padding;
  } else if (Array.isArray(theme.space) && padding > theme.space.length + 1) {
    return "".concat(padding, "px");
  } else {
    return "".concat(theme.space[padding], "px");
  }
}
export function getPaddingMapFromPaddingProp(padding, side) {
  var paddingMap = createBreakpointMap(padding);
  var sides = {
    left: '0px',
    right: '0px',
    top: '0px',
    bottom: '0px'
  };
  Object.keys(paddingMap).forEach(key => {
    if (typeof paddingMap[key] === 'number') {
      paddingMap[key] = getPaddingValueFromStyledSystemNumber(paddingMap[key]);
    }

    sides = parseSides(paddingMap[key]);
    paddingMap[key] = sides[side];
  });
  return paddingMap;
}